import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const MaterialPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [error, setError] = useState("");
  const [rooms, setRoom] = useState([]);

  const handleSave = async () => {
    if (name.trim() === "") {
      setError("Room Name is required.");
      return;
    }

    console.log(name);
    console.log(description);

    try {
      const response = await fetch("http://127.0.0.1:8000/api/material/create_room/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: name,
          description: description,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to save data");
      }

      const data = await response.json();
      console.log("Saved:", data);

      setShowModal(false);
      setName("");
      setDescription("");
      setError("");

    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    axios
      .get("http://127.0.0.1:8000/api/material/rooms_listing/")
      .then((response) => setRoom(response.data))
      .catch((error) => console.error("Error fetching Rooms:", error));
  }, []);

  return (
    <div className="container mt-4">

      {/* Add Button */}
      <button
        className="btn btn-primary mb-4"
        onClick={() => setShowModal(true)}
      >
        + Add New Record
      </button>
      {rooms.length === 0 ? (
        <p className="text-center">No Rooms found.</p>
      ) : (
        rooms.map((room) => (

          <div className="card text-center mb-4" >
            <div className="card-header">
              {room.created_at}
            </div>

            <div className="card-body">
              <h5 className="card-title">
                {room.roomname}
              </h5>

              <p className="card-text">
                {room.room_description}
              </p>

              <div className="card-footer text-center">
                <Link to={`/construction/material_room/room_code/${room.roomid}`} className="btn btn-primary">
                  View
                </Link>
              </div>
            </div>
          </div>
        ))
      )
      }



      {/* Modal */}
      {
        showModal && (
          <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
          >
            <div className="modal-dialog">
              <div className="modal-content">

                <div className="modal-header">
                  <h5 className="modal-title">Add New Record</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setShowModal(false);
                      setError("");
                    }}
                  ></button>
                </div>

                <div className="modal-body">
                  <div className="mb-3">
                    <label className="form-label">
                      Room Name <span className="text-danger">*</span>
                    </label>

                    <input
                      type="text"
                      className={`form-control ${error ? "is-invalid" : ""}`}
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                        setError("");
                      }}
                    />

                    {error && (
                      <div className="invalid-feedback">
                        {error}
                      </div>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Description</label>
                    <textarea className="form-control"
                      value={description}
                      onChange={(e) => {
                        setDescription(e.target.value);
                        setError("");
                      }}></textarea>
                  </div>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      setShowModal(false);
                      setError("");
                    }}
                  >
                    Close
                  </button>

                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </div>

              </div>
            </div>
          </div>
        )
      }

    </div >
  );
};

export default MaterialPage;